exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".vDPSrGeQ58CePLAJu0Ok1{max-width:300px;text-align:center;margin:0 auto}\n", ""]);

// Exports
exports.locals = {
	"CreateAccountStep": "vDPSrGeQ58CePLAJu0Ok1"
};